import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Montana = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Montana Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. No laws requiring seller disclosure; caveat emptor applies.
        </Text>

        <Text style={styles.listItem}>
          2. Broker Property Disclosure Statement: Required by law.
        </Text>

        <Text style={styles.listItem}>
          3. Septic System Disclosure: Required if applicable.
        </Text>

        <Text style={styles.listItem}>
          4. Montana is a "buyer beware" state, which means that the buyer
          assumes total responsibility for a property once they have purchased
          it. However, when the property is being sold by an agent, the agent is
          required to disclose any "adverse facts" to the buyer.
        </Text>

        <Text style={styles.listItem}>
          5. MOLD DISCLOSURE: There are many types of mold. Inhabitable
          properties are not, and cannot be, constructed to exclude mold.
          Moisture is one of the most significant factors contributing to mold
          growth. Information about controlling mold growth may be available
          from your county extension agent or health department. Certain strains
          of mold may cause damage to property and may adversely affect the
          health of susceptible persons, including allergic reactions that may
          include skin, eye, nose, and throat irritation. Certain strains of
          mold may cause infections, particularly in individuals with suppressed
          immune systems. Some experts contend that certain strains of mold may
          cause serious and even life-threatening diseases. However, experts do
          not agree about the nature and extent of the health problems caused by
          mold or about the level of mold exposure that may cause health
          problems. The Centers for Disease Control and Prevention is studying
          the link between mold and serious health conditions. The seller,
          landlord, seller's agent, buyer's agent, or property manager cannot
          and does not represent or warrant the absence of mold. It is the
          buyer's or tenant's obligation to determine whether a mold problem is
          present. To do so, the buyer or tenant should hire a qualified
          inspector and make any contract to purchase, rent, or lease contingent
          upon the results of that inspection. A seller, landlord, seller's
          agent, buyer's agent, or property manager who provides this mold
          disclosure statement, provides for the disclosure of any prior testing
          and any subsequent mitigation or treatment for mold, and discloses any
          knowledge of mold is not liable in any action based on the presence of
          or propensity for mold in a building that is subject to any contract
          to purchase, rent, or lease.
        </Text>

        <Text style={styles.listItem}>
          6. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          7.{' '}
          <Text style={styles.underline}>
            Montana Property Disclosure Statement
          </Text>{' '}
          – In Montana, the broker is required to complete this form, providing
          potential buyers with details regarding the condition of the property
          and any known defects or issues.
        </Text>
      </View>
    </View>
  );
};

export default Montana;
